import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import I18N from '@arreeba/ristoranti-frontend-lib/lib/helpers/i18n';

const formatExtraCost = (c, property, index) => {
  const negative = c.type.toLowerCase() === 'negative';
  const plusOrMinus = negative ? '- ' : ' ';
  const classes = classnames(
    'cartTotal__extraCostItem',
    { 'cartTotal__extraCostItem--discount accent': negative },
  );
  if (property === 'label') {
    return (
      <p key={index} className={classes}>{c.label}</p>
    );
  }
  return (
    <p key={index} className={classes}>{plusOrMinus}{I18N.formatPrice(c.amount)}</p>
  );
};

const CartTotal = (props) => (
  <div className="cartTotal">
    <div className="cartTotal__labels">
      <p className="cartTotal__Item--subtotal">SUBTOTALE</p>
      { props.extraCosts.map((c, index) => formatExtraCost(c, 'label', index)) }
      <p className="cartTotal__Item--total">TOTALE</p>

    </div>
    <div className="cartTotal__amounts">
      <p className="cartTotal__Item--subtotal">{I18N.formatPrice(props.subtotal)}</p>
      { props.extraCosts.map((c, index) => formatExtraCost(c, 'cost', index)) }
      <p className="cartTotal__Item--total">{I18N.formatPrice(props.total)}</p>
    </div>
  </div>
);

CartTotal.propTypes = {
  total: PropTypes.number.isRequired,
  subtotal: PropTypes.number.isRequired,
  extraCosts: PropTypes.arrayOf(PropTypes.shape({
    amount: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
};

export default CartTotal;



// WEBPACK FOOTER //
// ./src/components/cart/cart-total.js